import React from "react";
import PropTypes from "prop-types";
import "./style.less";
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import shihuo from "shihuo-lib/dist/shihuo-lib";

class PipelineModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false
    }

    if (typeof window !== 'undefined') {
      const pathArr = window.location.pathname.split('/')
      const legoPageId = +pathArr[pathArr.length - 2]
      this.pageOptions = {
        id: props['customAttributes']['data-component-id'],
        legoPageId,
        legoPageTitle: document.title,
      }
    }
  }

  componentDidMount() {
    if (this.props.visible) {
      this.setVisible(true)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.visible !== nextProps.visible) {
      this.setVisible(nextProps.visible)
    }
  }

  handleItemClick = (item, index) => {
    this.setVisible(false)

    shihuo.uploadTrack({
      pti: {
        id: '^legoDialog:button:' + index,
        pageOptions: this.pageOptions
      }
    })

    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (!item.link) {
      return
    }
    const options = {
      link: item.link,
      sort: index
    }

    const convertUrl = utils.convertHref(item.link)
    utils.jumpToUrl(this.props.routeParams,convertUrl, item.link, options, -1, this.props, false)

    this.setVisible(false)
  }

  handleImgClick = (imgLink) => {
    shihuo.uploadTrack({
      pti: {
        id: '^legoDialog:image',
        pageOptions: this.pageOptions
      }
    })

    if (!imgLink) {
      return
    }

    this.setVisible(false)

    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: imgLink,
        props: this.props,
      })
      return
    }
    const options = {
      link: imgLink,
    }

    const convertUrl = utils.convertHref(imgLink)
    utils.jumpToUrl(this.props.routeParams,convertUrl, imgLink, options, -1, this.props, false)
  }

  setVisible = (visible) => {
    const { customAttributes, config, triggerId } = this.props
    const { popTimes, triggerType } = config.baseConfig
    if (visible && popTimes != '') {
      let key = customAttributes['data-component-id']
      if (triggerType === '点击后唤起') {
        key = `${triggerId}_${key}`
      }
      const times = +(window.localStorage.getItem(key) || 0)
      if (times >= popTimes) {
        return
      }
      localStorage.setItem(key, `${times + 1}`)
    }
    if (triggerType === '点击后唤起') {
      if (!visible) {
        this.props.onClose && this.props.onClose()
      }
    } else {
      this.setState({
        visible
      }, () => {
        if (!visible) {
          this.props.onClose && this.props.onClose()
        }
      })
    }

    if (visible) {
      shihuo.uploadTrack({
        pti: {
          id: '^legoDialog:show',
          pageOptions: this.pageOptions
        }
      })
    }
  }

  handleClose = () => {
    this.setVisible(false)
    shihuo.uploadTrack({
      pti: {
        id: '^legoDialog:close',
        pageOptions: this.pageOptions
      }
    })
  }

  render() {
    const { baseConfig, buttonList = [] } = this.props.config
    const { img, imgLink, triggerType } = baseConfig
    const { visible } = triggerType === '点击后唤起' ? this.props : this.state

    return (
      <div
        className={visible ? "pipeline-modal show" : "pipeline-modal"}
        {...this.props['customAttributes']}
      >
        <div className={visible ? "modal-content show" : "modal-content"}>
          <img className="modal-img" alt="" src={utils.formatImgUrl(img, this.props.webpSupport)} onClick={this.handleImgClick.bind(this, imgLink)}/>
          <div className="bottom-btns">
            {
              buttonList.map((item, index) => {
                return (
                  <div
                    key={`btn_${index}`}
                    className="btn-item"
                    onClick={this.handleItemClick.bind(this, item, index)}
                  >
                    <img
                      alt=""
                      src={utils.formatImgUrl(item.btnImg, this.props.webpSupport)}
                      style={{
                        width: item.height ? 'auto' : '100%',
                        height: item.height ? px2rem(`${item.height}px`) : 'auto',
                      }}
                    />
                  </div>
                )
              })
            }
          </div>
          <div className="close" onClick={this.handleClose}></div>
        </div>
      </div>
    )
  }
}

PipelineModal.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineModal };
export default PipelineModal;



// WEBPACK FOOTER //
// ./components/pipeline-modal/index.js